<template>
  <DateColumn :date="column.manuallyApprovedAt" fallback="-" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import DateColumn from '@/components/GraphqlDataTable/columns/DateColumn.vue'

const PaymentRequestClientApprovalDateColumn = graphql(`
  fragment PaymentRequestClientApprovalDateColumn on PaymentRequest {
    id
    manuallyApprovedAt
  }
`)

const props = defineProps<{
  row: FragmentType<typeof PaymentRequestClientApprovalDateColumn>
}>()

const column = computed(() => useFragment(PaymentRequestClientApprovalDateColumn, props.row))
</script>

<style scoped></style>
